module.exports = __webpack_public_path__ + "img/8076c72.jpg";